const { InnerBlocks } = wp.blockEditor;

export default ({ className }) => {
    return (
        <>
            <div className={`ButtonText ${ className }`}>
                <InnerBlocks
                    template={[
                        ['core/group', { className: 'ButtonText-wrapper' }, [
                            ['core/spacer', { height: '45px', width: '100px' }],
                            ['core/heading', { className: 'ButtonText-title' }],
                            ['core/paragraph', { className: 'ButtonText-subtitle' }],
                            ['core/button', { className: 'ButtonText-btn' }],
                            ['core/spacer', { height: '45px', width: '100px' }]
                        ]]
                    ]}
                />
            </div>
        </>
    );
}